import { useEffect } from 'react';

export const ServiceWorkerRegistration: React.FC = () => {
  useEffect(() => {
    // Register service worker for ultra-fast redirects
    if ('serviceWorker' in navigator) {
      // Skip SW on iOS devices to avoid WebKit quirks causing blank screens
      const ua = navigator.userAgent || '';
      const isIOS = /iPad|iPhone|iPod/.test(ua);
      const isStandalone = (window.navigator as any).standalone === true || window.matchMedia?.('(display-mode: standalone)')?.matches;
      if (isIOS) {
        // Proactively unregister any existing registrations on iOS
        navigator.serviceWorker.getRegistrations?.().then((regs) => regs.forEach((r) => r.unregister())).catch(() => {});
        return;
      }

      // Unregister any legacy worker at /sw.js to prevent stale control
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => {
          registrations.forEach((reg) => {
            const scriptUrl = reg.active?.scriptURL || reg.waiting?.scriptURL || reg.installing?.scriptURL;
            if (scriptUrl && scriptUrl.endsWith('/sw.js')) {
              reg.unregister();
            }
          });
        })
        .catch(() => {});

      navigator.serviceWorker.register('/sw.v2.js', { scope: '/' })
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration);
          
          // Preload common redirects via service worker
          const commonPaths = [
            '/article/elf-warning-letters-guide-templates-examples',
            '/article/holiday-elf-working-parents-time-saving-tips',
            '/article/holiday-elf-teens-creative-ideas',
            '/article/christkind-tradition-modernized-elf-letter-bot',
            '/article/best-holiday-elf-response-letters-2025',
            '/article/holiday-elf-name-generator',
            '/article/creative-holiday-elf-arrival-ideas-2024'
          ];
          
          // Send preload message to service worker after a delay
          setTimeout(() => {
            if (registration.active) {
              registration.active.postMessage({
                type: 'PRELOAD_REDIRECTS',
                paths: commonPaths
              });
            }
          }, 2000);
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });
    }
  }, []);

  return null;
}; 